import { createSlice } from '@reduxjs/toolkit'
import { EncryptStorage } from 'encrypt-storage'

export const encryptStorage = new EncryptStorage(process.env.REACT_APP_STORAGE_KEY)

const initialState = {
	userInfo: encryptStorage.getItem('znxpefwwcs'),
	accessToken: null,
	refreshToken: encryptStorage.getItem('rft')
}

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setCredentials: (state, action) => {
			const { accessToken, userInfo, refreshToken } = action.payload

			if (userInfo) {
				state.userInfo = userInfo
			}

			if (accessToken) {
				state.accessToken = accessToken
			}

			if (refreshToken) {
				state.refreshToken = refreshToken
			}
		},
		logout: state => {
			state.userInfo = null
			state.accessToken = null
			state.refreshToken = null
		}
	}
})

export const { setCredentials, logout } = authSlice.actions

export default authSlice.reducer
